import React, { useEffect, useState } from "react";
import { Box, IconButton, Paper, Typography } from "@mui/material";
import { KeyboardArrowLeft, KeyboardArrowRight } from "@mui/icons-material";
import { basePath } from "./PseudoDatabase";
import {useBreakpoint} from "./useBreakpoint";

export const breakpoints = new Map();
breakpoints.set('xs', {width: '412',height: '300' });
breakpoints.set('sm', {width: '600',height: '436' });
breakpoints.set('md', {width: '900',height: '654' });
breakpoints.set('lg',{width: '1200',height: '870' });
breakpoints.set('xl', {width: '1300',height: '940'});

export default function SwipeablePictureViewer({ pictures, id }) {
    const [activeStep, setActiveStep] = useState(0);
    const [touchStart, setTouchStart] = useState(0);
    const [touchEnd, setTouchEnd] = useState(0);
    const [showOverlay, setShowOverlay] = useState(true); // State to control overlay visibility
    const maxSteps = pictures?.length;

    const handleNext = () => {
        setActiveStep((prevActiveStep) => (prevActiveStep + 1) % maxSteps);
        resetOverlayTimer(); // Reset overlay visibility timer on interaction
    };

    const handleBack = () => {
        setActiveStep((prevActiveStep) => (prevActiveStep - 1 + maxSteps) % maxSteps);
        resetOverlayTimer(); // Reset overlay visibility timer on interaction
    };

    const handleTouchStart = (e) => {
        setTouchStart(e.targetTouches[0].clientX);
    };

    const handleTouchMove = (e) => {
        setTouchEnd(e.targetTouches[0].clientX);
    };

    const handleTouchEnd = () => {
        if (touchStart - touchEnd > 75) {
            handleNext();
        }

        if (touchStart - touchEnd < -75) {
            handleBack();
        }
    };

    // Reset the overlay timer (show the overlay for 5 seconds)
    const resetOverlayTimer = () => {
        setShowOverlay(true);
        setTimeout(() => setShowOverlay(false), 5000); // Hide overlay after 5 seconds
    };

    // Set overlay hide timeout when component mounts or activeStep changes
    useEffect(() => {
        resetOverlayTimer();
    }, [activeStep]);

    useEffect(() => {
        if (id) {
            const index = pictures.findIndex((picture) => picture.id === id);
            if (index === -1) {
                setActiveStep(0);
            } else {
                setActiveStep(index);
            }
        }
    }, [id, pictures]);



    function  Size  ()  {
        const breakPoint = useBreakpoint();
        return breakpoints.get(breakPoint);
    }

    function generateUrl(currentImage) {
        const imageSize = Size();
        if (!currentImage) {
            return "";
        }
        return currentImage.orientation === "landscape"
            ? `${basePath}tr:w-${imageSize.width}/${currentImage.path}`
            : `${basePath}tr:h-${imageSize.height}/${currentImage.path}`;
    }

    const url = pictures ? generateUrl(pictures[activeStep]) : "";

    const currentPicture = pictures?.[activeStep];

    if (!currentPicture) {
        return null;
    }

    const { title, description, orientation } = currentPicture;
    const imageSize = Size();
    return (
        <Box
            sx={(theme) => ({
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                minHeight: "100vh",
                bgcolor: "#FFF",
                p: 2,
                [theme.breakpoints.down("sm")]: { p: "0" },
            })}
        >
            <Paper
                elevation={3}
                sx={{
                    // width: orientation === "landscape"
                    //     ? Math.min(currentPicture.width, 600)
                    //     : "100%",
                    maxWidth: "100%",
                    height: "auto",
                    borderRadius: 2,
                    overflow: "hidden",
                    bgcolor: "#FFF",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    position: "relative",
                }}
            >
                {/* Image Container */}
                <Box
                    sx={{
                        position: "relative",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        width: orientation === "landscape"
                            ? "100%"
                            : imageSize.height + 'px',
                        // height: orientation === "landscape"
                        //     ? { xs: "100%", sm: "calc(100vh - 200px)" }
                        //     : { xs: "100%", sm: "calc(100vh - 250px)" },
                        overflow: "hidden",
                        // maxHeight: { sm: orientation === "portrait"
                        //         ? "calc(100vh - 250px)"
                        //         : "calc(100vh - 200px)" },
                    }}
                    onClick={resetOverlayTimer} // Show overlay on click/tap
                    onTouchStart={handleTouchStart}
                    onTouchMove={handleTouchMove}
                    onTouchEnd={handleTouchEnd}
                >
                    <Box
                        component="img"
                        src={url}
                        alt={title || `Picture ${activeStep + 1}`}
                        sx={{
                            width: orientation === "landscape"
                                ? "100%"
                                : 'auto',
                            height: "100%",
                            objectFit: "cover", // Cover ensures the image fills the container
                        }}
                    />

                    {/* Title and Caption Overlay for Small Screens */}
                    {showOverlay && (
                        <Box
                            sx={{
                                display: { xs: "flex", sm: "none" }, // Only display on small screens
                                flexDirection: "column",
                                justifyContent: "flex-end",
                                alignItems: "center",
                                position: "absolute",
                                bottom: 0,
                                left: 0,
                                width: "100%",
                                bgcolor: "rgba(4, 4, 4, 0.3)", // Semi-transparent background for readability
                                color: "#FFF",
                                p: 1,
                                textAlign: "center",
                                transition: "opacity 0.6s ease-in-out", // Smooth fade effect
                                opacity: showOverlay ? 1 : 0,
                            }}
                        >
                            {title && (
                                <Typography
                                    variant="h7"
                                    sx={{
                                        whiteSpace: "nowrap",
                                        overflow: "hidden",
                                        textOverflow: "ellipsis",
                                    }}
                                >
                                    {title}
                                </Typography>
                            )}
                            {description && (
                                <Typography
                                    variant="body2"
                                    sx={{
                                        fontSize: "0.7rem",

                                    }}
                                >
                                    {description}
                                </Typography>
                            )}
                        </Box>
                    )}

                    {/* Navigation Buttons */}
                    <IconButton
                        onClick={handleBack}
                        disabled={maxSteps <= 1}
                        sx={{
                            position: "absolute",
                            top: "50%",
                            left: "0",
                            transform: "translateY(-50%)",
                            backgroundColor: "rgba(0, 0, 0, 0.5)",
                            color: "#FFF",
                            "&:hover": { backgroundColor: "rgba(0, 0, 0, 0.7)" },
                        }}
                    >
                        <KeyboardArrowLeft />
                    </IconButton>

                    <IconButton
                        onClick={handleNext}
                        disabled={maxSteps <= 1}
                        sx={{
                            position: "absolute",
                            top: "50%",
                            right: "0",
                            transform: "translateY(-50%)",
                            backgroundColor: "rgba(0, 0, 0, 0.5)",
                            color: "#FFF",
                            "&:hover": { backgroundColor: "rgba(0, 0, 0, 0.7)" },
                        }}
                    >
                        <KeyboardArrowRight />
                    </IconButton>
                </Box>

                {/* Title and Caption for Larger Screens */}
                <Box
                    sx={{
                        width: "100%",
                        maxWidth: orientation === "landscape"
                            ? `${Math.min(currentPicture.width, 600)}px`
                            : "100%",
                        textAlign: "center",
                        p: 2,
                        display: { xs: "none", sm: "block" }, // Only display on larger screens
                    }}
                >
                    {title && (
                        <Typography
                            variant="h6"
                            sx={{
                                mb: 1,
                                whiteSpace: "nowrap",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                            }}
                        >
                            {title}
                        </Typography>
                    )}
                    {description && (
                        <Typography
                            variant="body2"
                            sx={{
                                color: "#666",
                                whiteSpace: "nowrap",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                            }}
                        >
                            {description}
                        </Typography>
                    )}
                </Box>
            </Paper>
        </Box>
    );
}
